var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modal-privacy","title":_vm.modalData.title,"size":"lg","hide-footer":"","scrollable":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.modalData.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }